import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { APPCONFIG } from '../../../config';
import { Api } from '../../../providers/api'

@Component({
	selector: 'my-app-sidenav-menu',
	styles: [],
	template: require('./sidenav-menu.component.html')
})

export class AppSidenavMenuComponent {

	listGroups = [
		// {
		// 	name:"Tax Group",
		// 	alias:"taxGroup",
		// 	icon:"format_list_bulleted"
		// },
		{
			name: "Customer Group",
			alias: "customerGroup",
			icon: "format_list_bulleted"
		},
		{
			name: "Payment term",
			alias: "termsCode",
			icon: "format_list_bulleted"
		},
		{
			name: "Bad Product Conditions",
			alias: "badProductConditions",
			icon: "format_list_bulleted"
		},

		{
			name: "Shipping Services",
			alias: "shippingServices",
			icon: "format_list_bulleted"
		}
		// {
		// 	name:"Country",
		// 	alias:"country",
		// 	icon:"format_list_bulleted"
		// }
	]

	constructor(private router: Router, public api: Api) {
		localStorage.setItem("allowedTables", JSON.stringify(this.listGroups));
	}

	getIntelliRepUrl(): string {
		console.log('=== IntelliRep URL Debug ===');

		const url = (() => {
			switch ((APPCONFIG as any).ENVIRONMENT) {
				case 'LOCAL':
					return 'http://localhost:8086/';
				case 'DEV':
					// return (APPCONFIG as any).intelliRepURL;
					return 'https://salesrepapp.opraco.com/';

				case 'COMMERCIAL':
					return 'https://warehouseapp.opraco.com';
				default:
					// return (APPCONFIG as any).intelliRepURL;
					return 'https://salesrepapp.opraco.com/';
			}
		})();
		console.log('getIntelliRepUrl returning:', url);
		return url;
	}

	getIntelliStockUrl(): string {
		switch (APPCONFIG.ENVIRONMENT) {
			case 'LOCAL':
				return 'http://localhost:8087/';
			case 'DEV':
				return 'https://warehouseapp.opraco.com/';
			case 'COMMERCIAL':
				return 'https://warehouseapp.opraco.com/';
			default:
				return 'https://warehouseapp.opraco.com/';
		}
	}

	getWebStoreUrl(): string {
		console.log('=== WebStore URL Debug ===');
		const customerId = this.api.getADPCustomerUUID ? this.api.getADPCustomerUUID() : '';
		console.log('Customer ID:', customerId);

		const baseUrl = 'https://b2bstore.opraco.com/?custId=';
		const url = baseUrl + customerId;
		console.log('getWebStoreUrl returning:', url);
		return url;
	}

	openStore() {
		const storeUrl = this.getWebStoreUrl();
		console.log('openStore opening URL:', storeUrl);
		window.open(storeUrl, '_blank');
	}

	logout() {
		localStorage.removeItem(APPCONFIG.prefix + 'isLoggedIn');
		this.router.navigate(['/extra/login'], { queryParams: { logoutStatus: 'success' } });
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.ts